var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.485 2.291 9.9 3.622l-8.485 7.986L0 10.278z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 10.21 1.414-1.33L9.9 16.865l-1.414 1.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95 9.244h18v2h-18z"
  }))));
};
export default SvgRight;